import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { Chip } from "primereact/chip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarCNPJ, formatarCPF, formatarParaMoedaBRL } from "../../../utils";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";

 
 
 
export default function RestricaoAvancadaScore({
  restricaoAvancadaScore
}: {
  restricaoAvancadaScore: any
}) {
  const { t } = useTranslation();

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  };
 
  const getResumoRefin = () => {
    const resumos: any[] = [];
    if(restricaoAvancadaScore.dados && restricaoAvancadaScore.dados.refin && restricaoAvancadaScore.dados.refin.registro && restricaoAvancadaScore.dados.refin.registro.length > 0){
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Registros',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-calendar-clock',
        label: 'Última ocorrência',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      let data:Date|null = null
      restricaoAvancadaScore.dados.refin.registro.forEach((ocorrencia:any) => {
        quantidade ++;
        valorTotal = valorTotal + Number(ocorrencia.valor.replaceAll('.', '').replace(',', '.'))
        const [mes, ano, ] = ocorrencia.data_entrada.split(/[\/: ]/).map((v: string) => parseInt(v));
        const dataFormatada = new Date(ano, mes - 1);
        if(data == null || data < dataFormatada){
          data = dataFormatada
        }
        
      });
      resumos[1].value = (data ? formatDate(data) : '');
      resumos[0].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }
    return resumos;
  }
 
  const getResumo = () => {
    const resumos: any[] = [];
    if(restricaoAvancadaScore.dados && restricaoAvancadaScore.dados.pefin && restricaoAvancadaScore.dados.pefin.registro && restricaoAvancadaScore.dados.pefin.registro.length > 0){
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Registros',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-calendar-clock',
        label: 'Última ocorrência',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      let data:Date|null = null
      restricaoAvancadaScore.dados.pefin.registro.forEach((ocorrencia:any) => {
        quantidade ++;
        valorTotal = valorTotal + Number(ocorrencia.valor.replaceAll('.', '').replace(',', '.'))
        const [mes, ano, ] = ocorrencia.data_entrada.split(/[\/: ]/).map((v: string) => parseInt(v));
        const dataFormatada = new Date(ano, mes - 1);
        if(data == null || data < dataFormatada){
          data = dataFormatada
        }
        
      });
      resumos[1].value = (data ? formatDate(data) : '');
      resumos[0].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }
    return resumos;
  }
 
  const getResumoProtesto = () => {
    const resumos: any[] = [];
    if(restricaoAvancadaScore.dados.protesto && restricaoAvancadaScore.dados.protesto.registro.length > 0){
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Comarcas',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Quantidade Protestos',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      const comarcas: any[] = []
      restricaoAvancadaScore.dados.protesto.registro.forEach((prot:any) => {
        quantidade ++;
        valorTotal = valorTotal + Number(prot.valor.replace('.', '').replace(',', '.'))
        if(!comarcas.includes(prot.origem)){
          comarcas.push(prot.origem)
        }
      });
      resumos[0].value = comarcas.length;
      resumos[1].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }
    
    return resumos;
  }
 
  const numberFormat = (value:number, width:number) => {
    return new Array(width + 1 - (value + '').length).join('0') + value;
  }

  const naturezaTemplate = (item:any) => {
    return item.comprador ? 'Comprador' : 'Avalista';
  }

  const cnpjEmpresa = (item:any) => {
    return formatarCNPJ(item.cnpj);
  };

  const documentoSocio = (item:any) => {
    return item.documento.length == 11 ? formatarCPF(item.documento) : formatarCNPJ(item.documento);
  };

  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoAvancadaScore.dados.protesto.registro && restricaoAvancadaScore.dados.protesto.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestos')}</span>) }</div>;
  }

  const headerTemplateCCF = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoAvancadaScore.dados.cheque_sem_fundo.registro && restricaoAvancadaScore.dados.cheque_sem_fundo.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('ccf')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('ccf')}</span>) }</div>;
  }

  const headerTemplateRefin = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoAvancadaScore.dados.refin.registro && restricaoAvancadaScore.dados.refin.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('refins')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('refins')}</span>) }</div>;
  }

  const headerTemplatePefin = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoAvancadaScore.dados.pefin.registro && restricaoAvancadaScore.dados.pefin.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pefins')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pefins')}</span>) }</div>;
  }

  const formartData = (value:string) => {
    if(!value){
      return 'Não Informado';
    }
    value = value.split('T')[0];
    return value.substring(8,10) + '/' + value.substring(5,7) + '/' + value.substring(0,4);
  }

 
  
  return (
    <div>
    {restricaoAvancadaScore.mensagemErro ? (<p>{restricaoAvancadaScore.mensagemErro}</p>) :
    (
    <div>
      {restricaoAvancadaScore.dados.dados_cadastrais.cpf &&(
        <div>
          <Panel header={t('consumidor')}>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('documento')}</label>
                      <Chip style={{width:"100%"}} label={formatarCPF(numberFormat(restricaoAvancadaScore.dados.dados_cadastrais.cpf, 11))} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('nome')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.nome} />
                  </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('nomeMae')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.nome_mae} />
                  </div>
                </div>
                <div className="col">
                    <div >
                      <label className="label-dados">{t('situacao')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.situacao} />
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('dataNascimento')}</label>
                      <Chip style={{width:"100%"}} label={formartData(restricaoAvancadaScore.dados.dados_cadastrais.data_nascimento)} />
                  </div>
                </div>
                <div className="col">
                  <div >
                      <label className="label-dados">{t('idade')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.idade} />
                  </div>
              
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('sexo')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.sexo} />
                  </div>
                </div>
                <div className="col">
                  <div >
                      <label className="label-dados">{t('email')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.email} />
                  </div>
              
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('fone')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.ddd_res ? '(' + restricaoAvancadaScore.dados.dados_cadastrais.ddd_res + ') ' + restricaoAvancadaScore.dados.dados_cadastrais.telefone_res : 'Não Informado'} />
                  </div>
                </div>
                <div className="col">
                  <div >
                      <label className="label-dados">{t('celular')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.ddd_cel ? '(' + restricaoAvancadaScore.dados.dados_cadastrais.ddd_cel + ') ' + restricaoAvancadaScore.dados.dados_cadastrais.telefone_cel : 'Não Informado'} />
                  </div>
              
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('endereco')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.endereco ?  restricaoAvancadaScore.dados.endereco.logradouro + ', ' + restricaoAvancadaScore.dados.endereco.numero + (restricaoAvancadaScore.dados.endereco.complemento ? ' - ' + restricaoAvancadaScore.dados.endereco.complemento : '') + ' - ' + restricaoAvancadaScore.dados.endereco.bairro + ' - ' + restricaoAvancadaScore.dados.endereco.cidade + '/' + restricaoAvancadaScore.dados.endereco.uf + ' - ' + restricaoAvancadaScore.dados.endereco.cep  : 'Não Informado'} />
                  </div>
                </div>
                
            </div>
          
          </Panel>
          <br></br>
          <Panel header={t('empresas')}>
            <DataTable size="small" value={restricaoAvancadaScore.dados.sociedade.registro} tableStyle={{ minWidth: '50rem' }}>
                <Column body={cnpjEmpresa} header={t('cnpj')}></Column>
                <Column field="situacao_rf" header={t('situacao')}></Column>
                <Column field="razao_social" header={t('razaoSocial')}></Column>
                <Column field="cargo" header={t('cargo')}></Column>
                <Column field="data_entrada" header={t('data')}></Column>
            </DataTable>
        
          </Panel>
    
          
        

           
         
        </div>
      ) }
    {restricaoAvancadaScore.dados.dados_cadastrais.cnpj &&(
        <div>
          <Panel header={t('consumidor')}>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('documento')}</label>
                      <Chip style={{width:"100%"}} label={formatarCNPJ(numberFormat(restricaoAvancadaScore.dados.dados_cadastrais.cnpj, 14))} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('razaoSocial')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.razao_social} />
                  </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('nomeFantasia')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.nome_fantasia} />
                  </div>
                </div>
                <div className="col">
                    <div >
                      <label className="label-dados">{t('naturezaJuridica')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.natureza_juridica_codigo ? restricaoAvancadaScore.dados.dados_cadastrais.natureza_juridica_codigo + ' - ' + restricaoAvancadaScore.dados.dados_cadastrais.natureza_juridica : 'Não Informado'} />
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('dataFundacao')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.data_fundacao} />
                  </div>
                </div>
                <div className="col">
                    <div >
                      <label className="label-dados">{t('situacao')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.situacao ? restricaoAvancadaScore.dados.dados_cadastrais.situacao : 'Não Informado'} />
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('email')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.email} />
                  </div>
                </div>
                <div className="col">
                    <div >
                      <label className="label-dados">{t('atividadePrincipal')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.dados_cadastrais.atividade_economica_principal_codigo ? restricaoAvancadaScore.dados.dados_cadastrais.atividade_economica_principal_codigo + ' - ' + restricaoAvancadaScore.dados.dados_cadastrais.atividade_economica_principal : 'Não Informado'} />
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('endereco')}</label>
                      <Chip style={{width:"100%"}} label={restricaoAvancadaScore.dados.endereco ?  restricaoAvancadaScore.dados.endereco.logradouro + ', ' + restricaoAvancadaScore.dados.endereco.numero + (restricaoAvancadaScore.dados.endereco.complemento ? ' - ' + restricaoAvancadaScore.dados.endereco.complemento : '') + ' - ' + restricaoAvancadaScore.dados.endereco.bairro + ' - ' + restricaoAvancadaScore.dados.endereco.cidade + '/' + restricaoAvancadaScore.dados.endereco.uf + ' - ' + restricaoAvancadaScore.dados.endereco.cep  : 'Não Informado'} />
                  </div>
                </div>
                
            </div>
           
          
          </Panel>
          <br></br>
        <Panel header={t('quadroSocietario')}>
            <DataTable size="small" value={restricaoAvancadaScore.dados.socio.registro} tableStyle={{ minWidth: '50rem' }}>
                <Column body={documentoSocio} header={t('documento')}></Column>
                <Column field="nome_rf" header={t('nome')}></Column>
                <Column field="cargo" header={t('cargo')}></Column>
            </DataTable>
        
        </Panel>
    
          
        

           
         
        </div>
      ) }
    
   
    <br></br>
    <Panel headerTemplate={headerTemplateProtesto}>
        {restricaoAvancadaScore.dados.protesto.registro.length === 0 ? ( <NadaConsta />) : (<>
          <div className="flex-consulta  flex-wrap gap-3">
                {getResumoProtesto().map((item:any, index:number) => (
                                 
                    <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                        <div className="flex-consulta  justify-content-between gap-5">
                            <div className="flex-consulta  flex-column gap-1">
                                <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                                <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                            </div>
                            <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                                <i className={item.icon} />
                            </span>
                        </div>
                    </Card>
                  
                  ))}
              </div>
        <DataTable size="small" value={restricaoAvancadaScore.dados.protesto.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_ocorrencia" header={t('data')}></Column>
            <Column field="cartorio" header={t('cartorio')}></Column>
            <Column field="cidade" header={t('cidade')}></Column>
            <Column field="uf" header={t('uf')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    <br></br>
    <Panel headerTemplate={headerTemplateRefin}>
        {restricaoAvancadaScore.dados.refin.registro.length === 0 ? ( <NadaConsta />) : (<>
        <div className="flex-consulta  flex-wrap gap-3">
          {getResumoRefin().map((item:any, index:number) => (
                            
              <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                  <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                          <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                          <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                          <i className={item.icon} />
                      </span>
                  </div>
              </Card>
            
            ))}
        </div>
        <br></br>
        <DataTable size="small" value={restricaoAvancadaScore.dados.refin.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_ocorrencia" header={t('data')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column body = {naturezaTemplate} header={t('natureza')}></Column>
            <Column field="origem" header={t('informante')}></Column>
            <Column field="cidade" header={t('cidade')}></Column>
            <Column field="uf" header={t('uf')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    <br></br>
    <Panel headerTemplate={headerTemplatePefin}>
        {restricaoAvancadaScore.dados.pefin.registro.length === 0 ? ( <NadaConsta />) : (<>
        <div className="flex-consulta  flex-wrap gap-3">
          {getResumo().map((item:any, index:number) => (
                            
              <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                  <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                          <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                          <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                          <i className={item.icon} />
                      </span>
                  </div>
              </Card>
            
            ))}
        </div>
        <br></br>
        <DataTable size="small" value={restricaoAvancadaScore.dados.pefin.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_ocorrencia" header={t('data')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column body = {naturezaTemplate} header={t('natureza')}></Column>
            <Column field="origem" header={t('informante')}></Column>
            <Column field="cidade" header={t('cidade')}></Column>
            <Column field="uf" header={t('uf')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    <br></br>
    <Panel headerTemplate={headerTemplateCCF}>
        {restricaoAvancadaScore.dados.cheque_sem_fundo.registro.length === 0 ? ( <NadaConsta />) : (<>
        <DataTable size="small" value={restricaoAvancadaScore.dados.cheque_sem_fundo.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_ultima_ocorrencia" header={t('dataUltimaOcorrencia')}></Column>
            <Column field="quantidade_cheques" header={t('quantidade')}></Column>
            <Column field="agencia" header={t('agencia')}></Column>
            <Column field="banco" header={t('banco')}></Column>
            <Column field="nome_banco" header={t('nomeBanco')}></Column>
        </DataTable>
        </>)}
    </Panel>

    </div>)}
  </div>
  )
}